import logo from "../assets/maritaca_logo.png";

export default function NotFound() {
    return (
        <div className="relative flex min-h-screen w-full items-center justify-center overflow-hidden bg-secondary px-4 py-10 font-sans">
            <div className="z-10 flex w-full max-w-[500px] flex-col items-center gap-8 rounded-xl border border-border bg-card p-12 text-center shadow-sm md:p-12 sm:p-8">
                <div className="relative">
                    <img src={logo} alt="Maritaca logo" className="h-32 w-32" />
                </div>

                <div className="flex flex-col gap-3">
                    <h1 className="text-6xl font-bold leading-tight text-destructive sm:text-5xl">404</h1>
                    <h2 className="text-2xl font-semibold leading-tight tracking-tight text-foreground sm:text-xl">
                        O endereço acessado não existe
                    </h2>
                    <p className="mx-auto max-w-md text-base text-muted-foreground sm:text-sm">
                        A página que você está procurando não foi encontrada ou pode ter sido movida.
                    </p>
                </div>

                <a
                    href="/"
                    className="inline-flex items-center justify-center rounded-md bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground shadow-[0_1px_2px_rgba(60,66,87,0.12)] transition-colors hover:bg-primary/90"
                >
                    ← Voltar para a página inicial
                </a>

                <div className="w-full border-t border-border pt-6">
                    <h3 className="mb-3 text-center text-base font-semibold text-foreground">
                        Você pode estar procurando por:
                    </h3>
                    <div className="flex flex-col items-center gap-2">
                        <a href="/gastos" className="rounded-md px-4 py-1.5 text-sm font-medium text-muted-foreground transition-colors hover:bg-primary/10 hover:text-primary">
                            Dashboard
                        </a>
                        <a href="/chaves-de-api" className="rounded-md px-4 py-1.5 text-sm font-medium text-muted-foreground transition-colors hover:bg-primary/10 hover:text-primary">
                            Chaves de API
                        </a>
                        <a href="/modelos" className="rounded-md px-4 py-1.5 text-sm font-medium text-muted-foreground transition-colors hover:bg-primary/10 hover:text-primary">
                            Modelos
                        </a>
                    </div>
                </div>
            </div>

            <footer className="absolute bottom-6 left-1/2 z-10 -translate-x-1/2">
                <p className="text-center text-xs text-muted-foreground">© 2025 Maritaca AI</p>
            </footer>
        </div>
    );
}
